/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import * as qs from 'query-string';
import { createAxiosRequestWithSecondaryAuthSupport } from 'blb-utils/secondaryAuth';
export const axiosDefaults = {
  headers: {
    'Cache-control': 'no-store',
    'client-name': 'blend-bridge',
    Expires: '0',
    Pragma: 'no-cache',
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: params => qs.stringify(params)
};
const axiosInstance = createAxiosRequestWithSecondaryAuthSupport(axiosDefaults);
axiosInstance.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && error.response?.data.location) {
    window.location.replace(error.response.data.location);
  }
  return Promise.reject(error);
});
export const baseRequest = axiosInstance;